export const CONFIG = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    CLIENT_DASHBOARD_BASE_URI: process.env.REACT_APP_CLIENT_DASHBOARD_BASE_URI,
    CLIENT_OLD_DASHBOARD_BASE_URI: process.env.REACT_APP_CLIENT_OLD_DASHBOARD_BASE_URI,
    CLIENT_CHARGE_DASHBOARD_BASE_URI: process.env.REACT_APP_CLIENT_CHARGE_DASHBOARD_BASE_URI,
};
